import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 8px;
  height: 32px;

  & > div {
    width: 100%;

    & > div {
      width: 50%;
    }
  }
`;
